import { Alert, Text } from "@/atoms"
import { DisconnectOutlined } from "@/icons"
import {
  ConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { FormDockerHub } from "@/pages/IntegrationsPage/components/molecules/FormDockerHub"
import { useDockerHubAPI } from "@/pages/IntegrationsPage/hooks/useDockerHubAPI"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { INTEGRATIONS_WRITE_PERMISSION } from "@/pages/IntegrationsPage/IntegrationsPage.constants"

import styles from "./DockerHubConfigurationPage.module.scss"

import type { DockerHubConfigurationItemProps } from "."

export const DockerHubConfigurationItem = (
  props: DockerHubConfigurationItemProps
) => {
  const { account, vendor } = props
  const [_, { onRemove, ...actions }] = useIntegration({ vendor })
  const { t } = actions
  const dockerHubApi = useDockerHubAPI({ account, ...actions })
  const { accountId, repositories, health } = account
  const showHealth = !!health && health.status !== "healthy"

  return (
    <ConfigItem
      values={{ id: accountId, name: accountId, health }}
      Description={
        <Text type="secondary">
          {t("integrations.dockerHub.repositoriesCount", {
            count: repositories.length
          })}
        </Text>
      }
    >
      <div className={styles.body}>
        {showHealth && health.message && (
          <Alert
            showIcon
            type={health.status === "unhealthy" ? "error" : "warning"}
            message={health.message}
          />
        )}
        <FormDockerHub
          formId={dockerHubApi.formId}
          account={account}
          onFinish={dockerHubApi.onFinish}
          {...actions}
        />
      </div>
      <FooterConfigItem
        formId={dockerHubApi.formId}
        isDirty={actions.isDirty}
        isPending={dockerHubApi.isPending || actions.isPending}
        permissions={INTEGRATIONS_WRITE_PERMISSION}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove({ id: accountId, name: accountId })}
        onReset={actions.onReset}
      />
    </ConfigItem>
  )
}
